import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvsbThankYouMailComponent } from './evsb-thank-you-mail.component';
import { EvsbThankYouMailService } from './evsb-thank-you-mail.service';
import { EvsbThankYouMailMapper } from './evsb-thank-you-mail.mapper';
import CardModule from '../../libs/component-lib/components/card/card.module';
import MediaObjectModule from '../../libs/component-lib/components/media-object/media-object.module';
import CardBodyModule from '../../libs/component-lib/components/card-body/card-body.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import CardHeaderModule from '../../libs/component-lib/components/card-header/card-header.module';
import { TranslateModule } from '@ngx-translate/core';
import ButtonModule from '../../libs/component-lib/components/button/button-module';

@NgModule({
  declarations: [EvsbThankYouMailComponent],
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    CardBodyModule,
    CardHeaderModule,
    MediaObjectModule,
    AngularSvgIconModule,
    ButtonModule,
  ],
  exports: [EvsbThankYouMailComponent],
  providers: [EvsbThankYouMailService, EvsbThankYouMailMapper],
})
export class EvsbThankYouMailModule {}
